export function escapeRegExp(str) {
  if (str == null) return str;
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
